module.exports = {
  "Calendar": "/calendar.png",
  "Microsoft": "/microsoft.png",
  "Microsoft Calendar": "/microsoft.png",
  "Google Calendar": "/googlecalendar.png"
}